import { render, staticRenderFns } from "./DisclosurePolicy.vue?vue&type=template&id=e8c1aa7a"
import script from "./DisclosurePolicy.vue?vue&type=script&lang=js"
export * from "./DisclosurePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports